/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * The color map is used to map a background color token to a matching text color that will meet contrast.
 *
 * @codegen <<SignedSource::d95eddb0600202d29d6e9478fa7c9283>>
 * @codegenCommand yarn codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::c829bed8504655cd09b971d338d7f3a1>>
 */
export default {
  'neutral.bold': 'inverse',
  'neutral.bold.hovered': 'inverse',
  'neutral.bold.pressed': 'inverse',
  'selected.bold': 'inverse',
  'selected.bold.hovered': 'inverse',
  'selected.bold.pressed': 'inverse',
  'brand.bold': 'inverse',
  'brand.bold.hovered': 'inverse',
  'brand.bold.pressed': 'inverse',
  'danger.bold': 'inverse',
  'danger.bold.hovered': 'inverse',
  'danger.bold.pressed': 'inverse',
  'warning.bold': 'warning.inverse',
  'warning.bold.hovered': 'warning.inverse',
  'warning.bold.pressed': 'warning.inverse',
  'success.bold': 'inverse',
  'success.bold.hovered': 'inverse',
  'success.bold.pressed': 'inverse',
  'discovery.bold': 'inverse',
  'discovery.bold.hovered': 'inverse',
  'discovery.bold.pressed': 'inverse',
  'information.bold': 'inverse',
  'information.bold.hovered': 'inverse',
  'information.bold.pressed': 'inverse',
} as const;
